import Echo from "laravel-echo";
import Pusher from "pusher-js";
import service from "@/utils/request";

window.Pusher = Pusher;

export const socket = new Echo({
  broadcaster: "reverb",
  key: process.env.VUE_APP_REVERB_APP_KEY,

  wsHost: process.env.VUE_APP_REVERB_HOST,
  wsPort: Number(process.env.VUE_APP_REVERB_PORT),
  wssPort: Number(process.env.VUE_APP_REVERB_PORT),

  forceTLS: process.env.VUE_APP_REVERB_SCHEME === "https",
  enabledTransports: ["ws", "wss"],

  authorizer: channel => ({
    authorize(socketId, callback) {
      service.post('/broadcasting/auth', {
        socket_id: socketId,
        channel_name: channel.name,
      }, {
        baseURL: process.env.VUE_APP_BASE_URL.replace(/\/api(?:\/sis)?\/?$/, ''),
      }).then(data => callback(null, data)).catch(error => callback(error));
    },
  }),
});
